import React from "react";

const PortfolioTemplateDownload = ({ title, download }) => {
  function handleDownload() {
    const url = `${process.env.PUBLIC_URL}/docs/RGSImpact1.pdf`;
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "RGSImpact1.pdf");
    document.body.appendChild(link);
    link.click();
  }

  return (
    <a
      target="_blank"
      href="/docs/RGSImpact1.pdf" //TODO NORMAL TEMPLATE CSV FILE
      download="RGSImpact.pdf"
      className="w-fit mx-auto flex justify-center shadow bg-gray-50 rounded-xl"
    >
      <div className="inline-flex space-x-4 items-center justify-start p-4  w-fit">
        <img className="w-6 h-full" src="/icon/template_doc.svg" />
        <p className="text-sm leading-tight text-gray-600">
          Download our template
        </p>
        <img
          className="flex-1 h-6 rounded-lg cursor-pointer"
          src="/redesign/portfolio_impact/download.svg"
        />
      </div>
    </a>
  );
};

export default PortfolioTemplateDownload;
